import "./aho2-newuser-button.styles.scss";
const AHO2NewUser = ({ handleModal }) => {
  return (
    <div className="aho2-newuser">
      <span className="aho2-newuser-button" onClick={handleModal}>
        New User
      </span>
    </div>
  );
};
export default AHO2NewUser;
